/**
 * @description A simple function that wraps a specified function in a debouncer such that,
 *  every time THIS function is called it will wait a specified amount of time before calling
 *  the wrapped function.  This is useful for handling keyboard user events.
 * @param fn {Function} - function to be debounced
 * @param wait {number} - the amount of time to debounce the function call
 * @returns {Function} - a debounced function
 */

const DEFAULT_DEBOUNCE = 300;

function debounce (fn, wait = DEFAULT_DEBOUNCE) {
  let id = null;

  return function runner (...args) {
    const context = this;

    // Everytime this function is called again, clear the timer that came before it
    clearTimeout(id);

    // Apply a new timer and call the wrapped function when its finished
    id = setTimeout(() => {
      fn.apply(context, args);
    }, wait);
  }
}

export default debounce;
